import React, { useContext, useEffect, useState } from "react";
import { GlobalStateContext } from "./App";

const obtenerNivelDesdeURL = () => { const path = window.location.pathname.toLowerCase(); 
  if (path.includes("/posgrados/maestrias")) { return "maestrias"; } 
  if (path.includes("/posgrados/doctorados")) { return "doctorados"; } 
  if (path.includes("/posgrados/especialidades")) { return "especialidad"; } 
return null; 

};


const FiltroPrograma = ({ fPosgrado, setItem, DataNivel, DataCamp, DataFac }) => {
  const {
    idCampus,
    setidCampus,
    idNivel,
    setidNivel,
    idFacultad,
    setidFacultad,
    filtraUniversidad
  } = useContext(GlobalStateContext);

// NUEVO: establecer automáticamente el nivel según la URL 
useEffect(() => { 
  const nivelURL = obtenerNivelDesdeURL(); 
  if (!nivelURL || !DataNivel?.length) { return; } 
  const nivelEncontrado = DataNivel.find((val) => { 
  const nombreNivel = val.nivel ?.toLowerCase() .normalize("NFD") .replace(/[\u0300-\u036f]/g, ""); 
  if (nivelURL === "maestrias") { return nombreNivel.includes("maestria"); } 
  if (nivelURL === "doctorados") { return nombreNivel.includes("doctorado"); } 
  if (nivelURL === "especialidad") { return nombreNivel.includes("especialidad"); } 
  return false; }); 
  if (nivelEncontrado) { 
    setidNivel(String(nivelEncontrado.id_nivel)); } }, [DataNivel, setidNivel]);

  useEffect(() => {
    fPosgrado(idCampus, idNivel, idFacultad);
  }, [idCampus, idNivel, idFacultad, fPosgrado]);

  const nivelURL = obtenerNivelDesdeURL();
  return (
    <>
      <div className="container">
        <div className="row">
          <form className="contact-form form-group" >
            <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 ">
              <div>
                <label>Campus de Interés: </label>
              </div>

              <select className="select" value={idCampus} onChange={(e) => setidCampus(e.target.value)}>
                <option value="all">Todos los campus</option>
                {DataCamp.map((val, index) => (
                  <option value={val.id} key={index}>
                    {val.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 ">
              <div>
                <label>Nivel de Interés: </label>
              </div>


              <select className="select" value={idNivel} disabled={!!nivelURL} onChange={(e) => setidNivel(e.target.value)} > {!nivelURL && ( <option value="all">Todos los niveles</option> )} {DataNivel.map((val, index) => ( <option value={val.id_nivel} key={index}> {val.nivel} </option> ))} </select>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 ">
              <div>
                <label>Área Académica: </label>
              </div>

              <select className="select" value={idFacultad} onChange={(e) => setidFacultad(e.target.value)}>
                <option value="all">Todas las facultades</option>
                {DataFac.map((val, index) => (
                  <option value={val.id_facultad} key={index}>
                    {val.facultad}
                  </option>
                ))}
              </select>
            </div>
          </form>
        </div>

      </div>

    </>

  );
};

export default FiltroPrograma;


           /*   <select className="select" value={idNivel} onChange={(e) => setidNivel(e.target.value)}>
                <option value="all">Todos los niveles</option>
                {DataNivel.map((val, index) => (
                  <option value={val.id_nivel} key={index}>
                    {val.nivel}
                  </option>
                ))}
              </select> */